import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import moment from 'moment-jalaali'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Grid,
  TextField,
} from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import { getGroups } from '../../app/slices/refereeGroupsSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'
import { getAllUsersPackage, selectorExtendUsersPackage, unluckUserPackage } from '../../app/slices/packageSlice'
import CustomToolbar from '../../utils/CustomToolbar'
import { fixNumbers } from '../../utils/getInitials'

const useStyles = makeStyles(() => ({
  root: {
    '&.MuiPaper-root': {
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  extendDialog: {
    '& .MuiDialog-paperWidthSm': {
      width: '50%',
      height: 'auto',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
      '@media (max-width: 960px)': {
        width: '60%',
      },
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#e8cea2, #f9b233)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  extendModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#1b6edb',
    textAlign: 'center',
    border: '2px solid #1b6edb',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#1b6edb',
      color: '#ffffff',
    },
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      color: '#ffffff',
    },
  },
}))

const ExtendsList = () => {
  const extendUsersPackages = useSelector(selectorExtendUsersPackage)
  const classes = useStyles()

  const dispatch = useDispatch()
  const [packageId, setPackageId] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const { t } = useTranslation()

  const [extendDate, setExtendDate] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [currentPage, setCurrentPage] = useState(0)
  const [searchTerm, setSearchTerm] = useState([])

  useEffect(() => {
    dispatch(getGroups({}))
    dispatch(getAllUsersPackage({
      UserIds: searchTerm,
      Statuses: [106],
      after: currentPage * rowsPerPage,
      first: rowsPerPage,
    }))
  }, [refresh, rowsPerPage, currentPage, window.outerWidth])

  console.log('extendUsersPackages', extendUsersPackages)

  const COLUMNS = [
    {
      name: 'id',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p style={{
              color: '#000',
              whiteSpace: 'nowrap',
              float: window.outerWidth < 960 ? 'left' : '',
            }}
            >
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'user',
      label: 'کد ملی',
      options: {
        sort: false,
        filter: true,
        searchable: true,
        customBodyRender: (value) => (
          <p
            style={{
              color: '#000',
              whiteSpace: 'nowrap',
              float: window.outerWidth < 960 ? 'left' : '',
            }}
          >
            {value?.userName}
          </p>
        ),
        filterOptions: {
          names: Array.from(new Set(extendUsersPackages?.map((ex) => ex?.user?.userName))),
        },
      },
    },
    {
      name: 'package',
      label: 'نام بسته آزمون',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <p
              style={{
                color: '#000',
                whiteSpace: 'pre-wrap',
                // width: 'auto !important',
                float: window.outerWidth < 960 ? 'left' : '',
              }}
            >
              {value?.name}

            </p>
          )
        },
        filterOptions: {
          fullWidth: true,
          names: Array.from(new Set(extendUsersPackages?.map((ex) => ex?.package?.name))),
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => (
          <p style={{
            color: '#000',
            whiteSpace: 'pre-wrap',
            // width: 'auto !important',
            float: window.outerWidth < 960 ? 'left' : '',
          }}
          >
            {moment(value)?.format('jYYYY/jMM/jDD')}
          </p>
        ),
        sort: false,
        filter: true,
      },
    },
    {
      name: 'package',
      label: 'قیمت',
      options: {
        customBodyRender: (value) => (
          <p style={{
            color: '#000',
            whiteSpace: 'pre-wrap',
            // width: 'auto !important',
            float: window.outerWidth < 960 ? 'left' : '',
          }}
          >
            {value?.price}
          </p>
        ),
        sort: false,
        filter: true,
      },
      filterOptions: {
        fullWidth: true,
        names: Array.from(new Set(extendUsersPackages?.map((ex) => ex?.package?.price))),
      },
    },
    {
      name: 'id',
      label: 'تمدید آزمون',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <Button
              style={{
                whiteSpace: 'pre-wrap',
                // width: 'auto !important',
                float: window.outerWidth < 960 ? 'left' : '',
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                setPackageId(value)
              }}
            >
              تمدید
            </Button>
          )
        },
      },
    },
  ]

  const handleClose = (shouldExtend) => {
    if (shouldExtend) {
      setRefresh(!refresh)
      const data = {
        id: packageId,
        Until: fixNumbers(extendDate.format('YYYY-MM-DD')),

      }
      dispatch(unluckUserPackage(data))
      setExtendDate(null)
      setPackageId(null)
    }
    setPackageId(null)
  }

  const updateSearchTerm = (term) => {
    const arr = []
    const filtered = extendUsersPackages?.find((item) => +item?.user?.userName === +term)
    console.log('filtered', filtered)
    if (filtered) {
      arr.push(filtered?.user?.userId)
      setSearchTerm(arr)
      console.log('searchTerm', searchTerm)
    }
  }

  return (
    <>
      <ThemeProvider theme={getMuiThemeWithoutPadding}>
        <MUIDataTable
          data={extendUsersPackages}
          columns={COLUMNS}
          options={{
            ...muiDefaultOptions,
            enableNestedDataAccess: '.',
            filterType: '',
            filter: false,
            serverSide: true,
            page: currentPage,
            rowsPerPage,
            searchPlaceholder: 'کد ملی مورد نظر خود را وارد کنید',
            onSearchClose: () => {
              setSearchTerm(null)
            },
            onTableChange: (action, state) => {
              switch (action) {
                case 'changeRowsPerPage':
                  setRowsPerPage(state.rowsPerPage)
                  break
                case 'changePage':
                  setCurrentPage(state.page)
                  break
                case 'search':
                  updateSearchTerm(state.searchText)
                  break
                default:
                  break
              }
            },
            rowHover: false,
            selectableRows: 'none',
          }}
        />
      </ThemeProvider>
      <Dialog
        className={classes.extendDialog}
        open={packageId}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">تمدید بسته آزمون</DialogTitle>
        <DialogContent>
          <Grid style={{ width: '100%' }}>
            <DatePicker
              className={classes.customInput2}
              okLabel={t('confirm')}
              cancelLabel={t('cancel')}
              clearLabel={t('clean')}
              id="birthday"
              name="birthDate"
              inputVariant="outlined"
              ToolbarComponent={CustomToolbar}
              clearable
              fullWidth
              margin="normal"
              todayLabel
              variant="dialog"
              label="تا تاریخ"
              labelFunc={(date) => (date?.isValid ? date.format('jYYYY/jMM/jDD') : '')}
              dir="rtl"
              InputLabelProps={{ dir: 'rtl' }}
              value={extendDate}
              onChange={(e) => {
                setExtendDate(e)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={
                    {
                      ...params.inputsProps,
                      placeholder: 'jYYYY/jMMMM/jDD',
                    }
                  }
                />
              )}
              DialogProps={{
                className: classes.datePicker,
              }}
            />
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.extendModalBtn} autoFocus>
            تمدید
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ExtendsList
